
import {Component, Vue} from 'vue-property-decorator';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';

extend('required', required);
extend('email', email);

@Component({
  name: 'newsletter-block',
  components: {
    ValidationProvider,
    ValidationObserver
  }
})

export default class extends Vue {
  private email: string = '';
  private message: null | string = null;
  private success: string | boolean | null = null;
  private isLoading: boolean = false;

  private async doSubscribe() {
    this.isLoading = true;
    try {
      const {data} = await this.$mageClient.post(`/rest/V1/newsletter/subscribe`, {email: this.email});
      this.message = data.message;
      this.success = data.success;

      (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(() => {
        window.rrApi.setProfile({
          "email": this.email,
          "isAgreedToReceiveMarketingMail": true
        });
      });

    } catch (e) {
      console.error(e);
      this.message = 'newsletter-validation-error';
    } finally {
      this.isLoading = false;
      this.success = false;
      setTimeout(() => {
        this.message = '';
        this.success = null;
      }, 4000);
    }
  }
}
